exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress[data-v-73c7bff9] {\n    height: 0.35rem;\n    margin-top: 0.3rem;\n}\n.fa-exclamation[data-v-73c7bff9] {\n    margin-right: 0.2rem;\n}\n", ""]);

// exports
